import React, { CSSProperties, useEffect, useRef } from 'react';

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

interface AdSenseSlotProps {
  slot: string;
  className?: string;
  format?: 'auto' | 'fluid';
  layoutKey?: string;
  fullWidthResponsive?: boolean;
  style?: CSSProperties;
}

const ADSENSE_CLIENT = 'ca-pub-3767316091269121';

const AdSenseSlot: React.FC<AdSenseSlotProps> = ({
  slot,
  className,
  format = 'auto',
  layoutKey,
  fullWidthResponsive = true,
  style
}) => {
  const slotRef = useRef<HTMLElement | null>(null);
  const hasRequestedAdRef = useRef(false);

  useEffect(() => {
    if (!slot || !slotRef.current || hasRequestedAdRef.current) {
      return;
    }

    if (typeof window === 'undefined' || !window.adsbygoogle) {
      return;
    }

    try {
      window.adsbygoogle.push({});
      hasRequestedAdRef.current = true;
    } catch (error) {
      console.error('Failed to request AdSense slot', error);
    }
  }, [slot]);

  if (!slot) {
    return null;
  }

  return (
    <ins
      ref={element => {
        slotRef.current = element;
      }}
      className={`adsbygoogle${className ? ` ${className}` : ''}`}
      style={{ display: 'block', ...style }}
      data-ad-client={ADSENSE_CLIENT}
      data-ad-slot={slot}
      data-ad-format={format}
      data-ad-layout-key={layoutKey}
      data-full-width-responsive={fullWidthResponsive ? 'true' : undefined}
    />
  );
};

export default AdSenseSlot;